/**
 * Neo features pin stack — Control / Grip / Power / Case.
 * Desktop (>=1024): sticky cover stack. Mobile: document flow, no pin.
 * Tall panels: top = vh - height so bottom flushes to viewport before pin.
 * Linger spacers between panels (50vh) add dwell before next cover — panels stay siblings of track.
 * --neo-pin-top follows KV bar when fixed.
 */
(function () {
  'use strict';

  var LG = 1024;

  function kvBarH() {
    var bar = document.querySelector('[data-lp-kv-bar].is-fixed');
    if (!bar) return 0;
    return Math.round(bar.getBoundingClientRect().height);
  }

  class NeoPin extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._onScroll = this._syncTop.bind(this);
      this._onResize = this._sync.bind(this);
      this._mq = window.matchMedia('(min-width: ' + LG + 'px)');
      this._onMq = this._sync.bind(this);
      if (this._mq.addEventListener) {
        this._mq.addEventListener('change', this._onMq);
      } else {
        this._mq.addListener(this._onMq);
      }
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize, { passive: true });
      this._barRo = new ResizeObserver(this._syncTop.bind(this));
      var bar = document.querySelector('[data-lp-kv-bar]');
      if (bar) this._barRo.observe(bar);
      this._panelRo = new ResizeObserver(this._syncPanelTops.bind(this));
      this._sync();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
      if (this._mq) {
        if (this._mq.removeEventListener) {
          this._mq.removeEventListener('change', this._onMq);
        } else {
          this._mq.removeListener(this._onMq);
        }
      }
      if (this._barRo) this._barRo.disconnect();
      if (this._panelRo) this._panelRo.disconnect();
    }

    _panels() {
      return this.querySelectorAll('.neo-pin__panel');
    }

    _syncTop() {
      var top = this._mq && this._mq.matches ? kvBarH() : 0;
      this.style.setProperty('--neo-pin-top', top + 'px');
      this._syncPanelTops();
    }

    _syncPanelTops() {
      var panels = this._panels();
      var i;
      if (!(this._mq && this._mq.matches)) {
        for (i = 0; i < panels.length; i++) {
          panels[i].style.top = '';
        }
        return;
      }
      var pinTop = kvBarH();
      var vh = window.innerHeight;
      var available = vh - pinTop;
      for (i = 0; i < panels.length; i++) {
        var panel = panels[i];
        var h = panel.offsetHeight;
        // Short: stick under KV bar. Tall: stick when bottom meets viewport bottom.
        panel.style.top = (h <= available ? pinTop : vh - h) + 'px';
      }
    }

    _observePanels() {
      if (!this._panelRo) return;
      this._panelRo.disconnect();
      if (!(this._mq && this._mq.matches)) return;
      var panels = this._panels();
      for (var i = 0; i < panels.length; i++) {
        this._panelRo.observe(panels[i]);
      }
    }

    _sync() {
      var pin = this._mq && this._mq.matches;
      this.classList.toggle('is-pin', pin);
      this.classList.toggle('is-flow', !pin);
      this._syncTop();
      this._observePanels();
      var self = this;
      requestAnimationFrame(function () {
        self._syncPanelTops();
      });
    }
  }

  if (!customElements.get('neo-pin')) {
    customElements.define('neo-pin', NeoPin);
  }
})();
